import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import SurveyService from '../../../../Services/surveyService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. SurveyAdmin always passes the selected survey (crudType=Update),
// so this is never invoked, but it keeps the windowDescription contract satisfied.
class SurveyEditItem {}

export default class EditSurveyWindowDescription {
  static titleForEdit = (item) => `Edit Survey: ${item.Name}`;
  static itemType = SurveyEditItem;
  static finishButtonLabel = 'Submit';
  static messageOnSuccess = 'Survey has been saved.';

  // MUST return the promise (wizard contract).
  static serviceFunction = (edited) => SurveyService.UpdateSurvey(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'IsUninvoiceable',
          label: 'Is Uninvoiceable?',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: [
            { label: 'No', value: false, disabled: false },
            { label: 'Yes', value: true, disabled: false },
          ],
        },
        {
          fieldName: 'SurveyType',
          label: 'Survey Type',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: [
            { label: '', value: '', disabled: false },
            { label: 'Calls Emails', value: 'CallsEmails', disabled: false },
          ],
        },
      ],
    },
  ];
}
